module.exports = __webpack_public_path__ + "static/recruit-kv-0c2c432f55ce9929f4da2504f417da5d.jpg";